import React from 'react';

export default function SectionHeading({ number, children }) {
  return (
    <div className="flex items-center mb-12 gap-6">
      <h2 className="flex items-baseline text-2xl md:text-3xl font-bold tracking-tight whitespace-nowrap">
        <span className="font-mono text-lg md:text-xl font-bold mr-2" style={{ color: 'rgba(45,212,191,0.8)' }}>0{number}.</span>
        <span style={{ background: 'linear-gradient(90deg,#f1f5f9,#94a3b8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          {children}
        </span>
      </h2>
      <div className="flex-grow h-px" style={{ background: 'linear-gradient(90deg,rgba(45,212,191,0.2),rgba(30,41,59,0.3))' }}></div>
    </div>
  );
}
